import AboutUs from "./AboutUs/AboutUs";
import Contact from "./Contact/Contact";
import CostEstimator from "./CostEstimator/CostEstimator";
import FacilityEstimate from "./Search/FacilityEstimate";
import ForgotPassword from "./SignIn/ForgotPassword";
import HomeFeed from "./Home/HomeFeed";
import Onboarding from "./Onboarding/Onboarding";
import PrivateRoute from "./PrivateRoute";
import React, { useEffect } from "react";
import ScrollToTop from "../ScrollToTop";
import Search from "./MobileSearch/Search";
import Settings from "./Settings/Settings";
import SignIn from "./SignIn/SignIn";
import SignOut from "./SignIn/SignOut";
import SignUp from "./SignUp/SignUp";
import UnlockAccount from "./SignIn/UnlockAccount";
import UserState from "./UserState";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";


function Routes() {

  useEffect(() => {
    document.title = "Handl Health";
  }, []);

  return (
    <div className="h-100">
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          <Route path="/feed" exact component={HomeFeed} />
          <Route path="/aboutus" exact component={AboutUs} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/facility_estimate" exact component={FacilityEstimate} />
          <Route path="/forgot_password" exact component={ForgotPassword} />
          <Route path="/onboarding" exact component={Onboarding} />
          <Route path="/search" exact component={Search} />
          <Route path="/signin" exact component={SignIn} />
          <Route path="/signout" exact component={SignOut} />
          <Route path="/signup" exact component={SignUp} />
          <Route path="/user_state" exact
           render={() => (
               <PrivateRoute path="/user_state" component={UserState} />
           )}
          />
          <Route path="/unlock_account" exact component={UnlockAccount} />
          <Route
            path="/settings"
            render={() => (
              <PrivateRoute path="/settings" component={Settings} />
            )}
          />
          <Route
            exact
            path="/providers"
            render={() => (
              <PrivateRoute path="/providers" component={CostEstimator} />
            )}
          />
          <Route
            path="*"
            render={() => (
                <Redirect to="/providers" />
            )}
          />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default Routes;
